import { render, staticRenderFns } from "./campaignLinkModal.vue?vue&type=template&id=2d9f5f04&"
import script from "./campaignLinkModal.vue?vue&type=script&lang=js&"
export * from "./campaignLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./campaignLinkModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports